export const standards = [
  "ONC (g)(10)",
  "SMART on FHIR 2.0",
  "FHIR R4",
  "US Core 6.1.0",
];

export const technologies = [
  "ONC (g)(10)",
  "SMART on FHIR",
  "FHIR R4",
  "OAuth 2.0",
  "US Core 6.1.0",
  "Bulk Data",
  "Da Vinci PAS",
];

export const serviceBaseUrl =
  "https://aps-eus-connect-stg-gcerfhir-01.azurewebsites.net/metadata";

export const apiMaintenanceOfCertificationUrl =
  "https://www.healthit.gov/certification-health-it/conditions-ccg/application-programming-interfaces/";

export const apiResourceGuideUrl =
  "https://onc-healthit.github.io/api-resource-guide/";

export const fhirR4EndpointsBundleUrl = "/FHIR-R4-Endpoints-Bundle.json";
export const fhirR4EndpointsBundleFileName = "FHIR R4 Endpoints Bundle.json";

export const serviceBaseUrls = [
  {
    label: "Staging FHIR Endpoint",
    href: serviceBaseUrl,
    displayUrl: serviceBaseUrl,
  },
  {
    label: "FHIR R4 Endpoints Bundle",
    href: fhirR4EndpointsBundleUrl,
    displayUrl: fhirR4EndpointsBundleFileName,
  },
] as const;

/** Single public PDF used by View Documentation and Download PDF. */
export const healthcareApiDocsPdfUrl = "/Healthcare_API_Documentation.pdf";
export const healthcareApiDocsPdfFileName = "Healthcare_API_Documentation.pdf";
